export enum BuildLevel {
    Dev = 1,
    Prod,
}

export const Config ={
    GameVersion: "web1.1.4",
    BuildLevel: BuildLevel.Prod,
}